export const createScriptTag = (
    targetTag: HTMLElement = document.head,
    src: string,
    tagAttr?: { [key: string]: any },
    onload?: () => void,
): HTMLScriptElement => {
    const scriptTag = document.createElement('script');
    setTagAttributes(scriptTag, {
        src,
        ...tagAttr
    });

    if (onload) {
        scriptTag.onload = onload;
    }

    targetTag.appendChild(scriptTag);
    return scriptTag;
};

export const createStylesheetTag = (
    targetTag: HTMLElement = document.head,
    href: string,
    tagAttr?: { [key: string]: any },
): HTMLLinkElement => {
    const linkTag = document.createElement('link');
    setTagAttributes(linkTag, {
        href,
        type: 'text/css',
        rel: 'stylesheet',
        ...tagAttr
    });
    targetTag.appendChild(linkTag);
    return linkTag;
}
function setTagAttributes(tag: HTMLElement, attributes?: { [key: string]: any }) {
    if (attributes) {
        Object.keys(attributes).forEach((key: string) =>
            tag.setAttribute(key, attributes[key]),
        );
    }
}
